import { AnimatePresence, motion } from "framer-motion";
import { Play, Pause, X, Volume2 } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { fmtTime } from "@/lib/api";
import { BuyButton } from "./ReleaseCard";

export function PlayerBar() {
  const { track, playing, time, duration, volume, setVolume, toggle, seek, close } = usePlayer();
  return (
    <AnimatePresence>
      {track && (
        <motion.div
          data-testid="global-audio-player-bar"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 160, damping: 22 }}
          className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-4xl rounded-2xl border border-white/10 bg-[#131316]/90 p-3 shadow-2xl backdrop-blur-xl md:inset-x-6 md:p-4"
        >
          <div className="flex items-center gap-3 md:gap-5">
            <div className={`relative h-12 w-12 shrink-0 overflow-hidden rounded-full ring-2 ring-[var(--gold)]/50 ${playing ? "spin-fast" : ""}`}>
              <img src={track.cover} alt="" className="h-full w-full object-cover" />
              <span className="absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[var(--ink)]" />
            </div>
            <button data-testid="audio-player-play-pause-toggle" onClick={() => toggle()} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--gold)] text-[var(--ink)] transition-transform hover:scale-105 active:scale-95" aria-label={playing ? "Pause" : "Play"}>
              {playing ? <Pause size={16} fill="currentColor" /> : <Play size={16} fill="currentColor" className="ml-0.5" />}
            </button>
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-3">
                <p className="truncate font-display text-lg font-bold uppercase leading-none md:text-xl" data-testid="audio-player-title">{track.title}</p>
                <span className="shrink-0 font-mono text-xs text-[var(--stone)]">{fmtTime(time)} / {fmtTime(duration)}</span>
              </div>
              <input data-testid="audio-player-timeline-slider" type="range" min={0} max={duration || 0} step={0.1} value={time} onChange={(e) => seek(Number(e.target.value))} className="sw-range mt-2 w-full" aria-label="Position" />
            </div>
            <div className="hidden items-center gap-2 md:flex">
              <Volume2 size={15} className="text-[var(--stone)]" />
              <input data-testid="audio-player-volume-slider" type="range" min={0} max={1} step={0.01} value={volume} onChange={(e) => setVolume(Number(e.target.value))} className="sw-range w-20" aria-label="Volume" />
            </div>
            {!track.items?.length && <div className="hidden sm:block"><BuyButton track={track} item={track.itemIndex ?? null} compact /></div>}
            <button data-testid="audio-player-close" onClick={close} className="shrink-0 text-[var(--stone)] transition-colors hover:text-[var(--bone)]" aria-label="Close"><X size={18} /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
